import React, { FC, ReactNode } from 'react';
import { useRuntimeConfig } from '@/hooks/useRuntimeConfig';

type ConfigGateProps = {
  children: ReactNode;
};

/**
 * Blocks render until the runtime tenant config is loaded, so no consumer ever
 * reads a half-configured app. Renders nothing while config is absent.
 */
const ConfigGate: FC<ConfigGateProps> = ({ children }) => {
  const config = useRuntimeConfig();

  if (!config) {
    return null;
  }

  return <>{children}</>;
};

export default ConfigGate;
